import script from "./post-group-list.vue?vue&type=script&setup=true&lang=js"
export * from "./post-group-list.vue?vue&type=script&setup=true&lang=js"

import "./post-group-list.vue?vue&type=style&index=0&id=9c07a82e&scoped=true&lang=css"

import exportComponent from "/Users/timtsang/VueProject/test-2-2/test-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c07a82e"]])

export default __exports__